import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useIndicateIssues = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onGetIndicateIssuesError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while indicating issues.',
        );
    };

    const onGetIndicateIssuesSuccess = (callback: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Issues indicated successfully.');
        callback();
    };

    const setIndicateIssues = (data: {
        issue: string;
        status: string;
    }, driverId: string, callback: () => void) => {
        const url: HttpConfig = {
            url: `ba/v1/drivers/onboarding/update-status/${driverId}`,
            method: 'put',
            data,
        };

        request(url, onGetIndicateIssuesSuccess(callback), setLoading, onGetIndicateIssuesError);
    };

    return { setIndicateIssues, loading };
};

export default useIndicateIssues;
